import { SearchOutlined } from '@ant-design/icons'
import { Button, Input, notification } from 'antd'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Evaluation, archiveBeslutsstod, loadPersonsBeslutsstod } from '../../api/beslutsstod/beslutsstod'
import { useApi } from '../../api/useApi'
import { getMunicipality } from '../../store/beslutsstod/municipalitySlice'
import { InfoCard } from './components/infoCard'
import { validatePersonnummer } from './utils/validatePersonnummer'

const api = useApi()

const SearchBeslutsstod = () => {
  const municipalityData = useSelector(getMunicipality)
  const idLabel = municipalityData?.input.formSettings.nameProcessId ?? 'ID'
  const [prn, setPrn] = useState<string>('')
  const [processId, setProcessId] = useState<string>('')
  const [evaluations, setEvaluations] = useState<Evaluation[] | null>(null)
  const [notificationInstance, contextHolder] = notification.useNotification()
  const [previousParams, setPreviousParams] = useState<{ prn: string; processId: string } | null>(null)

  const onPrnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPrn(event.target.value)
  }

  const onProcessIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setProcessId(event.target.value)
  }

  const fetchData = async () => {
    if (!processId && !prn) {
      notificationInstance.error({
        message: `Skriv personnummer och/eller ${idLabel} för att söka`,
      })
      return null
    }
    const validatedPrn = prn ? validatePersonnummer(prn) : ''

    if (validatedPrn === null) {
      notificationInstance.error({
        message: 'Personnumret är inte giltigt',
      })
      return null
    }

    try {
      const result = await loadPersonsBeslutsstod(api, processId, validatedPrn)
      setEvaluations(result)
      setPreviousParams({ prn: validatedPrn, processId })
    } catch (error) {
      notificationInstance.error({
        message: 'Beräkningarna kunde inte hämtas',
      })
    }
  }

  const archive = async (id: number) => {
    try {
      await archiveBeslutsstod(api, id)
      if (!previousParams) return
      notificationInstance.success({
        message: 'Beräkningen har makulerats',
      })
      const result = await loadPersonsBeslutsstod(api, previousParams.processId, previousParams.prn)
      setEvaluations(result)
    } catch (error) {
      notificationInstance.error({
        message: 'Beräkningen kunde inte makuleras',
      })
    }
  }

  return (
    <>
      {contextHolder}
      <div style={{ paddingBottom: '20px', display: 'flex' }}>
        <Input placeholder="Personnummer" value={prn} onChange={onPrnChange} style={{ marginRight: '20px', width: '200px' }} />
        <Input placeholder={idLabel} type="number" value={processId} onChange={onProcessIdChange} style={{ marginRight: '20px', width: '200px' }} />
        <Button type="primary" onClick={fetchData} icon={<SearchOutlined />} style={{ display: 'flex', alignItems: 'center' }}>
          Sök
        </Button>
      </div>
      <div>
        {evaluations && evaluations.length === 0 && <div>Inga träffar</div>}
        {evaluations &&
          evaluations.map((obj, index) => (
            <InfoCard
              archive={async () => {
                archive(obj.id)
              }}
              key={index}
              evaluation={obj}
            />
          ))}
      </div>
    </>
  )
}

export default SearchBeslutsstod
